import React, { useState } from 'react';
import {
  Container,
  TextField,
  Typography,
  Box,
  Grid,
  Link,
  Alert,
} from '@mui/material';
import { auth, db } from './firebaseConfig';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { setDoc, doc } from 'firebase/firestore';
import routes from './routes';
import PrimaryButton from './components/PrimaryButton';

const Signup = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [cpf, setCpf] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});

  const handleSignup = async (e) => {
    e.preventDefault();
    setError('');
    setFieldErrors({});
    setIsLoading(true);

    const newFieldErrors = {};

    if (!name) newFieldErrors.name = 'Por favor, preencha este campo.';
    if (!email) newFieldErrors.email = 'Por favor, preencha este campo.';
    if (!password) newFieldErrors.password = 'Por favor, preencha este campo.';
    if (password !== confirmPassword) {
      newFieldErrors.confirmPassword = 'As senhas não coincidem.';
    }
    if (!birthDate) {
      newFieldErrors.birthDate = 'Por favor, preencha este campo.';
    } else {
      const birthDateObj = new Date(birthDate);
      const today = new Date();
      const age = today.getFullYear() - birthDateObj.getFullYear();
      const monthDiff = today.getMonth() - birthDateObj.getMonth();
      const dayDiff = today.getDate() - birthDateObj.getDate();
      if (age < 18 || (age === 18 && (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)))) {
        newFieldErrors.birthDate = 'Você deve ter pelo menos 18 anos.';
      }
    }
    if (!cpf) newFieldErrors.cpf = 'Por favor, preencha este campo.';
    if (!phone) newFieldErrors.phone = 'Por favor, preencha este campo.';

    if (Object.keys(newFieldErrors).length > 0) {
      setFieldErrors(newFieldErrors);
      setIsLoading(false);
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      await setDoc(doc(db, "userMetadata", user.uid), {
        name,
        birthDate,
        cpf,
        phone,
      });
    } catch (err) {
      console.error(err);
      setError('Erro ao criar conta. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h5">
          Crie sua conta
        </Typography>
        <Box component="form" onSubmit={handleSignup} sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            fullWidth
            id="name"
            label="Nome"
            name="name"
            autoComplete="name"
            autoFocus
            value={name}
            onChange={(e) => setName(e.target.value)}
            error={!!fieldErrors.name}
            helperText={fieldErrors.name}
          />
          <TextField
            margin="normal"
            fullWidth
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!fieldErrors.email}
            helperText={fieldErrors.email}
          />
          <TextField
            margin="normal"
            fullWidth
            name="password"
            label="Senha"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!!fieldErrors.password}
            helperText={fieldErrors.password}
          />
          <TextField
            margin="normal"
            fullWidth
            name="confirmPassword"
            label="Confirme a Senha"
            type="password"
            id="confirmPassword"
            autoComplete="current-password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            error={!!fieldErrors.confirmPassword}
            helperText={fieldErrors.confirmPassword}
          />
          <TextField
            margin="normal"
            fullWidth
            name="birthDate"
            label="Data de Nascimento"
            type="date"
            id="birthDate"
            InputLabelProps={{
              shrink: true,
            }}
            value={birthDate}
            onChange={(e) => setBirthDate(e.target.value)}
            error={!!fieldErrors.birthDate}
            helperText={fieldErrors.birthDate}
          />
          <TextField
            margin="normal"
            fullWidth
            name="cpf"
            label="CPF"
            id="cpf"
            value={cpf}
            onChange={(e) => setCpf(e.target.value)}
            error={!!fieldErrors.cpf}
            helperText={fieldErrors.cpf}
          />
          <TextField
            margin="normal"
            fullWidth
            name="phone"
            label="Celular"
            id="phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            error={!!fieldErrors.phone}
            helperText={fieldErrors.phone}
          />
          {error && (
            <Alert severity="error" sx={{ mt: 1 }}>
              {error}
            </Alert>
          )}
          <PrimaryButton
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 1 }}
            isLoading={isLoading}
          >
            Criar Conta
          </PrimaryButton>
          <Grid container justifyContent="flex-end" sx={{ mt: 1 }}>
            <Grid item>
              <Link href={routes.HOME} variant="body2">
                Já tem uma conta? Entre aqui
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
};

export default Signup;